import { v1 } from './v1';

export const dataUsage = {
  v1,
};
